import 'vite/modulepreload-polyfill';
import Registry from '../../../app/client/state/Registry';

import '@/ui/app.js';
import './styles/main.scss';

import brandTheme from './brandTheme';

if (typeof window !== 'undefined') {
  const body = document.querySelector('body');

  if (body) {
    Registry.applyTo(document, brandTheme);
  }
}
